var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('forget-password-ctrl',{attrs:{"propsList":_vm.propsList,"isExistUsername":_vm.isExistUsername},on:{"returnToLogin":_vm.returnToLogin,"sendSmsCode":_vm.sendSmsCode,"onIsExistUsername":_vm.onIsExistUsername,"resetPassword":_vm.resetPassword}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b881f84","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./third_party/common_app/LoginModule/View/Area/ForgetPasswordArea.vue
// module id = null
// module chunks = 